import { columnIndices, columnStyles, initialCellStyles, rows, styles } from './templateInstructionsBuilder.constants';
import { CellStyleConfig, ColumnDefinition } from '@common/xlsxExport/types';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

const getTableBodyStyles = (rowIndex: number) => ([
  {
    address: {
      row: rowIndex,
      column: columnIndices.columnName,
    },
    style: styles.columnNameBody,
  },
  {
    address: {
      row: rowIndex,
      column: columnIndices.description,
    },
    style: styles.columnBody,
  },
  {
    address: {
      row: rowIndex,
      column: columnIndices.sampleData,
    },
    style: styles.columnBody,
  },
]);

export type TemplateInstructionsBuilderColDef = ColumnDefinition & {
  templateMeta: {
    description: string,
    sampleData: string,
    required?: boolean,
  }
}

export type TemplateInstructionsBuilderSheet = {
  type: SheetExportTypes.TEMPLATE_INSTRUCTIONS,
  columnDefinitions: TemplateInstructionsBuilderColDef[],
  additionalInstructions: string[],
  title: string,
}
const templateInstructionsBuilder = (sheet: TemplateInstructionsBuilderSheet) => {
  const {
    columnDefinitions,
    additionalInstructions = [
      'Import data must be on the first worksheet (tab) of the workbook.',
      'Import Column headers listed here must be the only columns on the first sheet.',
    ],
    title = '',
  } = sheet;

  const cellStyles: CellStyleConfig[] = [
    ...initialCellStyles,
  ];


  const grid = [
    [`${title} - Import Format and Sample`, null, null, null, null, additionalInstructions.length ? 'Additional Instructions' : null],
    [],
    [null, 'Import Column', 'Description and Format', 'Sample Data'],
  ];

  columnDefinitions.forEach((columnDefinition, index) => {
    const {
      headerName,
      templateMeta: {
        description,
        sampleData,
        required,
      },
    } = columnDefinition;

    if (required) {
      cellStyles.push({
        address: {
          row: rows.tableData(index),
          column: 0,
        },
        style: styles.requiredMark,
      });
    }

    cellStyles.push(...getTableBodyStyles(rows.tableData(index)));

    grid.push([
      required ? '*' : null,
      headerName || null,
      description,
      sampleData,
    ]);
  });

  grid.push([
    null,
    '* Required data',
  ]);

  additionalInstructions.forEach((instruction, index) => {
    grid[rows.tableData(index)] = grid[rows.tableData(index)] || [];
    grid[rows.tableData(index)][columnIndices.additionalInstructions] = instruction;
  });

  cellStyles.push({
    address: {
      column: columnIndices.columnName,
      row: grid.length - 1,
    },
    style: styles.requiredMarkDescription,
  });

  const metadata = {
    sheetName: 'Instructions',
    cellStyles,
    columnStyles,
  };


  return {
    metadata,
    grid,
  };
};

export default templateInstructionsBuilder;
